import { Paper, Stack, Text, Title } from '@mantine/core';

import { useTranslation } from 'react-i18next';

export const OngoingDCERetrievalCard = () => {
  const { t } = useTranslation('notice');

  return (
    <Paper
      p="xl"
      shadow="lg"
      radius="sm"
      sx={theme => ({ border: `1px solid ${theme.colors.gray[0]}` })}
    >
      <Stack align="center">
        <Title order={4} c="gray.5">
          {t('documents.ongoingDceRetrievalCard.title')}
        </Title>
        <Text variant="sm" fw="400" c="gray.4">
          {t('documents.ongoingDceRetrievalCard.subtitle')}
        </Text>
      </Stack>
    </Paper>
  );
};
